import { render, staticRenderFns } from "./zsCan.vue?vue&type=template&id=e288ffb8&scoped=true"
import script from "./zsCan.vue?vue&type=script&lang=js"
export * from "./zsCan.vue?vue&type=script&lang=js"
import style0 from "./zsCan.vue?vue&type=style&index=0&id=e288ffb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e288ffb8",
  null
  
)

export default component.exports